<template>
  <div class="travel">
    <div class="travel__bar"></div>
    <div class="travel__body">
      <img
        src="@/assets/flag_italy.svg"
        alt=""
        class="flag"
        v-if="item.flag == 'italy'"
      />
      <img
        src="@/assets/flag_un.svg"
        alt=""
        class="flag"
        v-if="item.flag == 'everywhere'"
      />
      <img
        src="@/assets/flag_australia.svg"
        alt=""
        class="flag"
        v-if="item.flag == 'australia'"
      />
      <img
        src="@/assets/flag_france.png"
        alt=""
        class="flag"
        v-if="item.flag == 'france'"
      />
      <img src="@/assets/meeters-band.jpg" alt="" class="travel__band" />
      <div class="travel__hero">
        <p>{{ item.concept }}</p>
      </div>
      <h2 class="overline">Description</h2>

      <div class="travel__description">
        <p>{{ item.description }}</p>
      </div>

      <h2 class="overline">Promise</h2>

      <div class="travel__promise">
        <p>{{ item.promise }}</p>
      </div>
      <h2 class="overline">Justification</h2>
      <div class="travel__block">
        <ul>
          <li
            v-for="(li, index) in item.justification"
            :key="`justification-${index}`"
          >
            {{ li }}
          </li>
        </ul>
      </div>
    </div>

    <div class="travel__footer">
      <h2 class="overline">Pillars</h2>
      <ul>
        <li
          v-for="(li, index) in item.pillars"
          class="pillar"
          :key="`pillars-${index}`"
        >
          {{ li }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "TravelSite",
  props: {
    item: Object,
  },
};
</script>
